const initContact = {
	id: '',
	firstName: '',
	lastName: '',
	companies: [],
	image: { file: '', name: '', preview: '' },
	emailWork: '',
	emailPersonal: '',
	emailOther: '',
	contactPosition: '',
	phoneWork: { number: '', dialCode: '', countryCode: '', ext: '' },
	phoneMobile: { number: '', dialCode: '', countryCode: '', ext: '' },
	phoneOther: { number: '', dialCode: '', countryCode: '', ext: '' },
	note: '',
	addressWork: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	addressHome: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	addressOther: {
		address_id: '',
		type: '',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	},
	languages: [],
};

export default initContact;
